import {
  GET_USERS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  CREATE_USERS,
  UPDATE_USERS,
  DELETE_USERS,
} from "./actionType";

// common success
export const UsersApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const UsersApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const Users = () => ({
  type: GET_USERS,
});

export const CreateUsers = (data) => ({
  type: CREATE_USERS,
  payload: { data },
});

export const UpdateUsers = (data) => ({
  type: UPDATE_USERS,
  payload: { data },
});

export const DeleteUsers = (id) => ({
  type: DELETE_USERS,
  payload: { id },
});
